module.exports = __webpack_public_path__ + "static/media/icon2.5316d768.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/LAMI/icon2.svg
// module id = 93
// module chunks = 0